export default "__VITE_ASSET__CvE3vYFX__"